import { createFileRoute } from "@tanstack/react-router";
import { MfeLoader } from "../mfe/MfeLoader";
import { getAgentHostConfig } from "../config/agentHostConfig";
import { useHostNavigate } from "../hooks/useHostNavigate";
import { useViewport } from "../contexts/ViewportContext";
import { requireAuth } from "../utils/auth";
import { usePermissionState } from "../contexts/PermissionStateContext";

export const Route = createFileRoute("/agents/$")({
  beforeLoad: requireAuth,
  component: AgentsMfePage,
});

function AgentsMfePage() {
  const onNavigate = useHostNavigate();
  const { headerHeight } = useViewport();
  const permissionState = usePermissionState();

  return (
    <div
      className="overflow-hidden"
      style={{ height: `calc(100vh - ${headerHeight}px)` }}
    >
      <MfeLoader
        name="agent"
        props={{ hostConfig: getAgentHostConfig(onNavigate, permissionState) }}
      />
    </div>
  );
}
